import { defineSlotRecipe } from '@chakra-ui/react';

export const mapPopoverSlotRecipe = defineSlotRecipe({
    slots: ['container', 'closeButton'],
    base: {
        container: {
            position: 'relative',
            background: 'white',
            borderRadius: 'xl',
            animation: 'fadeSlideUp 0.25s ease forwards',
            fontFamily: '"proxima-nova", "proxima-nova-fallback", Arial, sans-serif',
        },
        closeButton: {
            zIndex: 2,
            position: 'absolute',
            top: 2,
            right: '10px',
            background: 'whiteAlpha.800',
            color: 'gray.900',
            fontWeight: 'bold',
            borderRadius: 'full',
            cursor: 'pointer',
            _hover: {
                background: 'whiteAlpha.900',
            },
        },
    },
    variants: {
        variant: {
            desktop: {
                container: {
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.3)',
                },
            },
            mobile: {
                container: {
                    position: 'fixed',
                    bottom: 2,
                    left: 0,
                    right: 0,
                    margin: '0 auto',
                    width: 'fit-content',
                    boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.15)',
                },
            },
        },
    },
});
